///
/// EarthBrowser
///
/// Created by Matt Giger on 1/6/2025
/// Copyright (c) 2025 Geodata Labs
///

import type { BetaTesterAddRequest, BetaTesterAddResponse } from "@shared-types/beta-tester"
import { authenticatedApi } from "./API/authenticatedApi"

const betaTesterApi = authenticatedApi.injectEndpoints({
	endpoints: (builder) => ({

		addBetaTester: builder.mutation<BetaTesterAddResponse, BetaTesterAddRequest>({
			query: (betaTester) => ({
				url: "/api/user/beta-tester",
				method: "POST",
				body: betaTester,
				headers: {
					"X-Turnstile-Token": betaTester.turnstileToken,
				},
			}),
			invalidatesTags: ["BetaTesters"],
		}),
	}),
})

export const { useAddBetaTesterMutation } = betaTesterApi
